import type { ExploreScopeSelection } from "@/analytics/core/types";

export function parseScopeIds(value: string | null): number[] {
  if (!value) return [];
  return value
    .split(",")
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isFinite(id) && id > 0);
}

export function parseScopeSelection(searchParams: URLSearchParams): ExploreScopeSelection {
  return {
    teamIds: parseScopeIds(searchParams.get("teams")),
    repIds: parseScopeIds(searchParams.get("reps")),
  };
}

export interface WriteScopeSelectionOptions {
  /** When true, persist `reps` even if zero or multiple teams are selected (raw rep-centric pages). */
  persistReps?: boolean;
}

export function writeScopeSelection(
  next: URLSearchParams,
  selection: ExploreScopeSelection,
  options?: WriteScopeSelectionOptions,
): void {
  if (selection.teamIds.length > 0) {
    next.set("teams", selection.teamIds.join(","));
  } else {
    next.delete("teams");
  }

  const persistReps = options?.persistReps ?? selection.teamIds.length === 1;
  if (selection.repIds.length > 0 && persistReps) {
    next.set("reps", selection.repIds.join(","));
  } else {
    next.delete("reps");
  }
}
